<template>
  <el-row :gutter="15">
    <el-dialog :visible.sync="contactsVisible" width="30%" @close="cancelContacts('contactsForm')">
      <el-form ref="contactsForm" :model="contactsForm" :rules="contactsRules" label-width="80px">
        <el-form-item label="关系" prop="relationCode">
          <!-- <el-cascader
            :show-all-levels="false"
            placeholder="请选择关系"
            v-model="contactsForm.relationCode"
            :options="relationCode"
            :props="{ expandTrigger: 'hover' }"
            @change="relationChange">
          </el-cascader> -->
          <el-select v-model="contactsForm.relationCode" placeholder="请选择关系" @change="relationChange">
            <el-option v-for="(item, index) in relationCode" :key="index" :label="item.label"
              :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="姓名" prop="contactName">
          <el-input
            placeholder="请输入姓名"
            v-model="contactsForm.contactName">
          </el-input>
        </el-form-item>
        <el-form-item label="联系号码" prop="contactPhone">
          <el-input
            placeholder="请输入联系号码"
            v-model="contactsForm.contactPhone">
          </el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="typeCode">
          <el-select v-model="contactsForm.typeCode" placeholder="请选择联系方式" @change="dictionaryChange">
            <el-option v-for="(item, index) in dictionaryList" :key="index" :label="item.label"
              :value="item.value" />
          </el-select>
          <!-- <el-cascader
            :show-all-levels="false"
            placeholder="请选择联系方式"
            v-model="contactsForm.typeCode"
            :options="dictionaryList"
            :props="{ expandTrigger: 'hover' }"
            @change="dictionaryChange">
          </el-cascader> -->
        </el-form-item>
      </el-form>
      <div style="margin-left: 80px;">
        <el-button type="primary" @click="submitContacts('contactsForm')"
          >提交</el-button
        >
        <el-button @click="cancelContacts('contactsForm')"
          >关闭</el-button
        >
      </div>
    </el-dialog>
    <el-col :span="9">
      <el-tabs type="border-card" value="contacts" class="contacts-related-info">
        <el-tab-pane label="联系人" name="contacts">
          <el-button
            type="primary" @click="contactsVisible = true" size="mini" style="margin-bottom: 10px;"
            >新增</el-button
          >
          <informationTable :tabledata="contactsInfo" type="contactsInfo" @rowClick="handleClickContactsInfo" @editOpen="editOpen" />
        </el-tab-pane>
        <!-- <el-tab-pane
          label="通讯录"
          name="directory"
        >
          <informationTable
            :tabledata="userContactsInfo"
            type="userContactsInfo"
            @rowClick="handleClickUserContactsInfo"
          />
        </el-tab-pane> -->
        <!-- <el-tab-pane
          label="通话详单"
          name="contact_records"
        >
          <informationTable
            :tabledata="userCallsInfo"
            type="userCallsInfo"
            @rowClick="handleClickUserCallsInfo"
          />
        </el-tab-pane>
        <el-tab-pane
          label="淘宝信息"
          name="taobao"
        >
          <informationTable
            :tabledata="userAddress"
            type="userAddress"
            @rowClick="handleClickUserCallsInfo"
          />
        </el-tab-pane>
        <el-tab-pane
          label="共债信息"
          name="obligation"
        >
          <informationTable
            :tabledata="contactsInfoLoans"
            type="obligation"
            @rowClick="handleClickUserCallsInfo"
          />
        </el-tab-pane> -->
        <el-tab-pane label="分案信息" name="division">
          <informationTable :tabledata="reportList" type="division" @rowClick="handleClickUserCallsInfo" />
        </el-tab-pane>
        <!-- <el-tab-pane
          label="电话信息"
          name="phone"
        >
          <informationTable
            :tabledata="userSMSRecord"
            type="phone"
            @rowClick="handleClickUserCallsInfo"
          />
        </el-tab-pane> -->
      </el-tabs>
    </el-col>

    <el-col :span="15">
      <el-card class="box-card work-area" :body-style="{ display: 'flex' }">
        <el-form ref="record" :inline="true" :model="record" :rules="rules" class="form-inline" >
          <el-form-item label="联系方式" prop="contactTypeCode">
            <el-select v-model="record.contactTypeCode" placeholder="请选择" @change="handleContactTypeChange($event, 'event')">
              <el-option v-for="(item, index) in contactTypeList" :key="index" :label="item.label"
                :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="联络人" prop="contactName">
            <el-input v-model.trim="record.contactName" placeholder="请填写" style="width: 120px"
              @input="lianluorenChange" />
          </el-form-item>
          <el-form-item label="联系电话" prop="contactPhone">
            <el-input maxlength="11" v-model.trim="record.contactPhone" placeholder="请填写" style="width: 120px"
              @input="lianxiPhoneChange" />
          </el-form-item>
          <el-form-item label="与借款人关系" prop="relationCode">
            <el-select v-model="record.relationCode" placeholder="请选择" style="width: 120px"
              @change="jiekuanGuanxiChange">
              <el-option v-for="(item, index) in relationCode" :key="index" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="通话类型" prop="callTypeCode">
            <el-radio-group v-model="record.callTypeCode" @change="handleRecordCallTypeChange">
              <el-radio v-for="(item, index) in callTypData" :key="index" :label="item.value">{{ item.label
                }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <br>
          <el-form-item label="通话结果" prop="contactResultCode">
            <el-select v-model="record.contactResultCode" placeholder="请选择" @change="handleCallStatuChange">
              <el-option v-for="(item, index) in contactResultCode" :key="index" :label="item.label"
                :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="联系状态" prop="contactStatusCode">
            <el-select v-model="record.contactStatusCode" placeholder="请选择">
              <el-option v-for="(item, index) in contactStatusList" :key="index" :label="item.label"
                :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="yuqiYuanyin && isNeedOverdueReason" label="逾期原因" prop="overdueReasonCode">
            <el-select v-model="record.overdueReasonCode" placeholder="请选择" filterable @change="handleCallResulChange">
              <el-option v-for="(item, index) in overdueReasonCode" :key="index" :label="item.label"
                :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="yuqiYuanyin && isNeedOverdueReason && chengnuoTime" label="承诺还款时间" prop="promiseRepayTime">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="record.promiseRepayTime"  type="datetime" placeholder="选择日期时间" />
          </el-form-item>
          <el-form-item v-if="yuqiYuanyin && isNeedOverdueReason && tuifeiStatus" label="是否退费" prop="isRefund">
            <el-radio-group v-model="record.isRefund">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-row>
            <el-form-item label="催记内容" prop="remindeContent">
              <el-input v-model.trim="record.remindeContent" type="textarea" :rows="5" placeholder="请填写" maxlength="300"
                show-word-limit style="min-width: 300px" />
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="是否报案" prop="isBaoAn">
              <el-switch :disabled="disabledBaoAn"  v-model="isBaoAn" active-color="#2D8CF0" inactive-color="#C4C4C4"></el-switch>
            </el-form-item>
            <el-form-item v-if="isBaoAn" label="报案原因" prop="caseRean">
              <el-cascader
                :show-all-levels="false"
                placeholder="请选择报案原因"
                v-model="caseRean"
                :options="caseReanList"
                :props="{ expandTrigger: 'hover' }"
                @change="caseReanChange">
              </el-cascader>
            </el-form-item>
          </el-row>
          <!-- <el-form-item label="通话备注" prop="remarks">
            <el-input v-model.trim="record.remarks" type="textarea" placeholder="请填写" style="min-width: 300px" />
          </el-form-item>
          <el-form-item label="下次跟进时间" prop="nextCallTime">
            <el-date-picker v-model="record.nextCallTime"  type="datetime" placeholder="选择日期时间" />
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="onRecord('record')">保存</el-button>
          </el-form-item>
        </el-form>
        <div id="ctiIframe"></div>
      </el-card>
      <!-- <div class="label-wrapper">
        <el-tag v-for="(item, index) in taskLabel" :key="index">{{ item.name }}</el-tag>
      </div> -->
    </el-col>
  </el-row>
</template>

<script>
import informationTable from './informationTable'
import { mapActions, mapGetters } from 'vuex'
// import Lib from './lib.js'
import { getDictionaryList, getContactList, getContactByTaskIdAndContactId, getCaseRean, getCaseReanByFatherId, recordCollectionLog, addOrUpdateContact } from '@/api/task'
import callInit from '@/utils/call'

export default {
  name: 'item-work-log-info',
  components: {
    'informationTable': informationTable
  },
  props: {
    loanId: {
      type: [Number, String],
      required: true
    },
    taskId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      record: {
        callTypeCode: 'out',
        creatorId: null,
        contactName: '',
        contactPhone: '',
        relationCode: '',
        contactStatusCode: '',
        contactResultCode: '',
        caseRean: ''
      },
      isBaoAn: false,
      caseRean: '',
      caseReanList: [],
      contactsVisible: false,
      contactsRules: {
        contactName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        contactPhone: [{ required: true, message: '请输入联系号码', trigger: 'blur' }],
        typeCode: [{ required: true, message: '请选择联系方式', trigger: 'change' }],
        relationCode: [{ required: true, message: '请选择关系', trigger: 'change' }]
      },
      contactsForm: {
        id: null,
        contactName: '',
        contactPhone: '',
        typeCode: '',
        relationCode: '',
        customerName: '',
        customerPhone: '',
        typeName: '',
        relationName: '',
        dataResource: 'recordCollection'
      },
      dictionaryList: [],
      rules: {
        contactTypeCode: [{ required: true, message: ' ', trigger: 'blur' }],
        contactName: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        relationCode: [
          { required: true, message: ' ', trigger: 'change' }
        ],
        callTypeCode: [
          { required: true, message: ' ', trigger: 'change' }
        ],
        contactResultCode: [
          { required: true, message: ' ', trigger: 'change' }
        ],
        contactStatusCode: [
          { required: true, message: ' ', trigger: 'change' }
        ],
        overdueReasonCode: [
          { required: true, message: ' ', trigger: 'change' }
        ],
        remarks: [
          { required: true, message: ' ', trigger: 'change' }
        ],
        promiseRepayTime: [
          { required: true, message: ' ', trigger: 'change' }
        ],
        isRefund: [
          { required: true, message: '请选择是否退费', trigger: 'change' }
        ],
        caseRean: [
          { required: true, message: ' ', trigger: 'change' }
        ],
        remindeContent: [
          { required: true, message: ' ', trigger: 'change' }
        ]
      },
      relationCode: [],
      contactResultCode: [],
      contactStatusCode: [],
      overdueReasonCode: [],
      callTypData: [],
      contactTypeList: [],
      getContacSelectData: {
        taskId: null,
        contactType: null
      },
      newLinshiHuixian: {},
      yuqiYuanyin: false,
      isNeedOverdueReason: false,
      val1: '',
      val2: '',
      val3: '',
      chengnuoTime: false,
      tuifeiStatus: false,
      contactStatusList: [],
      isCallReady: false
    }
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'contactsInfo',
      'userContactsInfo',
      'userCallsInfo',
      'userAddress',
      'contactsInfoLoans',
      'reportList',
      'taskLabel',
      'userSMSRecord',
      'taskInfo',
      'borrowerInfo'
    ]),
    disabledBaoAn() {
      const _val = (this.val1 === 'self' || this.val1 === 'wechat' || this.val1 === 'self_second') && this.val2 === 'connected'
      if (_val && this.val3 == '6') {
        return true
      }
      return false
    }
  },
  async created() {
    this.fetchContactsInfo({ taskId: this.taskId })
    // this.fetchUserContactsInfo({ taskId: this.taskId })
    // this.fetchUserCallsInfo({ taskId: this.taskId })
    // this.fetchUserAddress({ taskId: this.taskId })
    this.fetchReportList({ taskId: this.taskId, page: 0, size: 100 })
    await this.getTaskLabel({ taskId: this.taskId })
    await this.fetchTaskInfo({ taskId: this.taskId });
    // this.fetchUserSMSRecord({ taskId: this.taskId })
    // 联系方式
    const contactDataType = await getDictionaryList('contact_type')
    // 联系方式仅展示：本人、微信、本人第二手机号码 isNeedNotOneself 0去掉，1不去
    contactDataType.data.map((item) => {
      if (this.taskInfo.isNeedNotOneself == '0') {
        if (item.dictValue === 'self' || item.dictValue === 'wechat' || item.dictValue === 'self_second') {
          this.contactTypeList.push({
            label: item.dictLabel,
            value: item.dictValue
          })
        }
      } else {
        this.contactTypeList.push({
          label: item.dictLabel,
          value: item.dictValue
        })
      }
      if (item.dictValue === 'other_contact' || item.dictValue === 'self_other') {
        this.dictionaryList.push({
          label: item.dictLabel,
          value: item.dictValue
        })
      }
    })
    console.log('taskInfo:',this.taskInfo)
    console.log('borrowerInfo:',this.borrowerInfo)
    this.contactsForm.customerPhone = this.borrowerInfo.phone
    this.contactsForm.customerName = this.borrowerInfo.name
    // 与借款人关系
    const contactRelatioData = await getDictionaryList('contact_relation')
    contactRelatioData.data.map((item) => {
      this.relationCode.push({
        label: item.dictLabel,
        value: item.dictValue
      })
    })
    // 通话结果
    const callStatuData = await getDictionaryList('contact_result')
    callStatuData.data.map((item) => {
      this.contactResultCode.push({
        label: item.dictLabel,
        value: item.dictValue
      })
    })
    // 联系状态
    const contactStatusCodeData = await getDictionaryList('contact_status')
    contactStatusCodeData.data.map((item) => {
      this.contactStatusList.push({
        label: item.dictLabel,
        value: item.dictValue
      })
    })
    this.taskLabel.map((item) => {
      // 有code为联系状态，否则为标签
      if (item.code) {
        this.record.contactStatusCode = item.code
      }
    })
    // 逾期原因
    const callResulData = await getDictionaryList('overdue_reason')
    callResulData.data.map((item) => {
      this.overdueReasonCode.push({
        label: item.dictLabel,
        value: item.dictValue
      })
    })
    // 通话类型
    const callTypeData = await getDictionaryList('call_type')
    callTypeData.data.map((item) => {
      this.callTypData.push({
        label: item.dictLabel,
        value: item.dictValue
      })
    })
    const userId = sessionStorage.getItem('userId')
    const username = this.getCookie('username')
    console.log('username', username)
    if (userId) {
      this.record.creatorId = userId
      console.log('User ID:', userId)
      // 在这里可以将userId存储在Vue组件的数据中，以便在组件中使用
    } else {
      console.log('User ID not found in cookie.')
    }

    await getCaseRean().then((res) => {
      if (res.data && res.data.length > 0) {
        this.caseReanList = []
        res.data.map((item, index) => {
          if (item.isHaveChildNode == '1') {
            this.caseReanList.push({
              value: item.pkid,
              label: item.caseName,
              children: []
            })
            this.getCaseReanByFatherIdMethod(item.pkid, this.caseReanList[index].children)
          } else {
            this.caseReanList.push({
              value: item.pkid,
              label: item.caseName
            })
          }
        })
      }
    })

    // this.initDYSDK()

    // const callLogin = {
    //   "status": 1,
    //   "data": {
    //     "account_id": 10703318,
    //     "token": "b2b1f551-0041-41af-ac39-515622076718"
    //   }
    // }
    this.handleTabFocus()
    // window.addEventListener('focus', this.handleTabFocus)
    // const script = document.createElement('script')
    // document.getElementById('ctiIframe').appendChild(script)
  },
  // destroyed() {
  //   // 清理事件监听器
  //   window.removeEventListener('focus', this.handleTabFocus);
  //   // window.removeEventListener('blur', this.handleTabBlur);
  // },
  methods: {
    handleTabFocus() {
      console.log(this.currentUser)
      callInit(this.currentUser,this.callFailF,this.callConfirmF)
      // 执行标签聚焦时的逻辑
    },
    editOpen(row) {
      // this.contactsForm = row
      this.contactsForm.id = row.id
      this.contactsForm.contactName = row.contactName
      this.contactsForm.contactPhone = row.contactPhone
      this.contactsForm.typeCode = row.typeCode
      this.contactsForm.relationCode = row.relationCode
      this.contactsForm.customerName = row.customerName
      this.contactsForm.customerPhone = row.customerPhone
      this.contactsForm.typeName = row.typeName
      this.contactsForm.relationName = row.relationName
      this.contactsForm.dataResource = row.dataResource
      this.contactsVisible = true
    },
    dictionaryChange(value) {
      console.log('v:',value)
      this.contactsForm.typeName = this.dictionaryList.find(item => item.value === value).label
    },
    relationChange(value) {
      this.contactsForm.relationName = this.relationCode.find(item => item.value === value).label
    },
    submitContacts(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addOrUpdateContact(this.contactsForm).then((res) => {
            console.log('res:',res)
            if (res.code === "00") {
              this.$message.success(res.msg);
              this.cancelContacts('contactsForm')
              this.fetchContactsInfo({ taskId: this.taskId })
              return;
            }
            this.$message.warning(res.msg);
          })
        }
      });
    },
    cancelContacts(formName) {
      this.contactsForm.id = null
      this.contactsForm.contactName = ''
      this.contactsForm.contactPhone = ''
      this.contactsForm.typeCode = ''
      this.contactsForm.relationCode = ''
      this.contactsForm.typeName = ''
      this.contactsForm.relationName = ''
      this.contactsForm.dataResource = ''
      this.contactsForm.customerPhone = this.borrowerInfo.phone
      this.contactsForm.customerName = this.borrowerInfo.name
      // this.$refs[formName].resetFields();
      this.contactsVisible = false
    },
    callFailF(data){
      this.record.contactResultCode = 'no_response'
      this.record.dyUuid = data.uuid
      console.log('callFailF',data)
      this.handleCallStatuChange('no_response')
      this.callreturn(data)
      // this.record.contactStatusCode = ''
    },
    callConfirmF(data){
      console.log('callConfirmF',data)
      this.record.contactResultCode = 'connected'
      this.record.dyUuid = data.uuid
      this.handleCallStatuChange('connected')
      this.callreturn(data)
    },
    callreturn(data){
      if(data.phone){
        let row = null
        for(let i=0;i<this.contactsInfo.length;i++) {
          let item = this.contactsInfo[i]
          if(item.contactPhone == data.phone){
            row = item
          }
        }
        this.newLinshiHuixian = row
        if(row){
          this.updateRecord({
            contactTypeCode: row.typeCode,
            contactName: row.contactName,
            contactPhone: row.contactPhone,
            relationCode: row.relationCode
          })
          this.handleContactTypeChange(row.typeCode, 'func')
        }else {
          this.handleContactTypeChange('other_contact', 'func')
          this.updateRecord({
            contactTypeCode: 'other_contact',
            contactName: '其他联系人',
            contactPhone: data.phone,
            relationCode: '9'
          })
        }
        this.newLinshiHuixian.isNeedOverdueReason == '1' ? this.isNeedOverdueReason = true : this.isNeedOverdueReason = false
      }
    },
    ...mapActions([
      'fetchContactsInfo',
      'fetchUserContactsInfo',
      'fetchUserCallsInfo',
      'fetchUserAddress',
      'fetchReportList',
      'getTaskLabel',
      'fetchCollectionLogs',
      'queryMertCaseList',
      'fetchUserSMSRecord',
      'fetchTaskInfo',
      'fetchBorrowerInfo'
    ]),
    async getCaseReanByFatherIdMethod(pkid, list) {
      await getCaseReanByFatherId({fatherId: pkid}).then((res) => {
        if (res.data && res.data.length > 0) {
          res.data.map((item, index) => {
            if (item.isHaveChildNode == '1') {
              list.push({
                value: item.pkid,
                label: item.caseName,
                children: []
              })
              this.getCaseReanByFatherIdMethod(item.pkid, list[index].children)
            } else {
              list.push({
                value: item.pkid,
                label: item.caseName
              })
            }
          })
        }
      })
    },
    caseReanChange(value) {
      this.record.caseRean = value[value.length - 1]
    },
    getCookie(name) {
      const cookieString = document.cookie
      const cookies = cookieString.split(';').map(cookie => cookie.trim())
      for (const cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split('=')
        if (cookieName === name) {
          return cookieValue
        }
      }
      return null // 如果未找到指定的 Cookie，则返回 null
    },
    handleClickContactsInfo(row, event, column) {
      console.log('handleClickContactsInfo:', row)
      this.updateRecord({
        contactTypeCode: row.typeCode,
        contactName: row.contactName,
        contactPhone: row.contactPhone,
        relationCode: row.relationCode
      })
      // DYSDK.copy2cti(row.contactPhone, function(data){
      //     console.log('copy done'+row.contactPhone)
      // })
      this.newLinshiHuixian = row
      this.handleContactTypeChange(row.typeCode, 'func')
      // this.newLinshiHuixian.isNeedOverdueReason == '1' ? this.isNeedOverdueReason = true : this.isNeedOverdueReason = false
    },
    handleClickUserContactsInfo(row, event, column) {
      this.updateRecord({
        contactName: row.name,
        contactPhone: row.phone,
        relationCode: '通讯录'
      })
    },
    handleClickUserCallsInfo(row, event, column) {
      this.updateRecord({
        contactPhone: row.phone,
        relationCode: '通话详单'
      })
    },
    handleRecordCallTypeChange(value) {
      this.updateRecord({
        contactResultCode: null
      })
    },
    handleContactTypeChange(val, type) {
      console.log(val, '联系方式')
      this.val1 = val
      const _val = (this.val1 === 'self' || this.val1 === 'wechat' || this.val1 === 'self_second') && this.val2 === 'connected'
      if (_val) {
        this.yuqiYuanyin = true
      } else {
        this.yuqiYuanyin = false
      }
      if (_val && this.val3 == '6') {
        this.isBaoAn = true
      }
      // if (this.record.contactResultCode !== 'connected') {
      //   this.yuqiYuanyin = false
      // }

      this.getContacSelectData.taskId = this.taskId
      this.getContacSelectData.contactType = val
      if (type === 'event') {
        getContactList(this.getContacSelectData).then((res) => {
          this.newLinshiHuixian = res.data
          console.log(this.newLinshiHuixian, 'this.newLinshiHuixian')
          if (res.data) {
            // 还要根据isNeedOverdueReason来判断要不要逾期原因，等于1就是要，0 就是不要
            res.data.isNeedOverdueReason == '1' ? this.isNeedOverdueReason = true : this.isNeedOverdueReason = false
            this.record.contactName = res.data.contactName
            this.record.contactPhone = res.data.contactPhone
            this.record.relationCode = res.data.relationCode
            this.$forceUpdate()
          } else {
            this.record.contactName = ''
            this.record.contactPhone = ''
            this.record.relationCode = ''
            this.$forceUpdate()
          }
        })
      } else {
        this.getContacSelectData.contactId = this.newLinshiHuixian.id
        getContactByTaskIdAndContactId(this.getContacSelectData).then((res) => {
          this.newLinshiHuixian = res.data
          console.log(this.newLinshiHuixian, 'this.newLinshiHuixian')
          if (res.data) {
            // 还要根据isNeedOverdueReason来判断要不要逾期原因，等于1就是要，0 就是不要
            res.data.isNeedOverdueReason == '1' ? this.isNeedOverdueReason = true : this.isNeedOverdueReason = false
            this.record.contactName = res.data.contactName
            this.record.contactPhone = res.data.contactPhone
            this.record.relationCode = res.data.relationCode
            this.$forceUpdate()
          } else {
            this.record.contactName = ''
            this.record.contactPhone = ''
            this.record.relationCode = ''
            this.$forceUpdate()
          }
        })
      }
      // if (val === 'other_contact') {
      //   this.record.contactName = ''
      //   this.record.contactPhone = ''
      //   this.record.relationCode = ''
      //   this.$forceUpdate()
      // }
    },
    handleCallStatuChange(val) {
      console.log(val, '通话结果')
      this.val2 = val
      const _val = (this.val1 === 'self' || this.val1 === 'wechat' || this.val1 === 'self_second') && this.val2 === 'connected'
      if (_val) {
        this.yuqiYuanyin = true
      } else {
        this.yuqiYuanyin = false
      }
      if (_val && this.val3 == '6') {
        this.isBaoAn = true
      }
      // if (this.record.contactTypeCode !== 'self') {
      //   this.yuqiYuanyin = false
      // }
    },
    handleCallResulChange(val) {
      console.log(val, '逾期原因')
      this.val3 = val
      const _val = (this.val1 === 'self' || this.val1 === 'wechat' || this.val1 === 'self_second') && this.val2 === 'connected'
      if (_val && this.val3 === '6') {
        this.isBaoAn = true
      }
      if (val === '0' || val === '1' || val === '2') {
        this.chengnuoTime = true
      } else {
        this.chengnuoTime = false
      }
      if (val === '4' || val === '5') {
        this.tuifeiStatus = true
      } else {
        this.tuifeiStatus = false
      }
    },
    lianluorenChange(data) {
      console.log(data, 'datadata')
      this.record.contactName = data
      this.$forceUpdate()
    },
    lianxiPhoneChange(data) {
      console.log(data, 'datadata')
      this.record.contactPhone = data
      this.$forceUpdate()
    },
    jiekuanGuanxiChange(val) {
      if (val) {
        this.$forceUpdate()
      }
    },
    onRecord(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm('确认提交?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.record.taskId = this.taskId
            this.record.creatorId = this.currentUser.id
            // if (this.record.nextCallTime) {
            //   this.record.nextCallTime = Lib.formatDate(this.record.nextCallTime)
            // }
            // if (this.record.promiseRepayTime) {
            //   this.record.promiseRepayTime = Lib.formattedDateTime(this.record.promiseRepayTime)
            // }
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
            recordCollectionLog(this.record).then(res => {
              console.log('recordCollectionLog res:',res)
              loading.close()
              if(res.code === '00') {
                this.$message({
                  type: 'success',
                  message: '提交成功!'
                })
                this.isBaoAn = false
                this.caseRean = ''
                this.record = {
                  callTypeCode: 'out'
                }
                this.yuqiYuanyin = false
                this.tuifeiStatus = false
                setTimeout(async () => {
                  this.fetchContactsInfo({ taskId: this.taskId })
                  await this.fetchBorrowerInfo({ taskId: this.taskId })
                  this.fetchCollectionLogs({ contractNumber: this.borrowerInfo.contractNumber, page: 0, size: 5, userId: this.currentUser.id })
                  this.queryMertCaseList({
                    contractNumber: this.borrowerInfo.contractNumber,
                    page: 0,
                    size: 5,
                  });
                  this.getTaskLabel({ taskId: this.taskId })
                }, 800)
              } else {
                this.$message.error('出错了: '+res.msg);
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    updateRecord(params) {
      this.record = {
        ...this.record, ...params
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.label-wrapper {
  margin: 10px 0;

  span {
    margin-right: 10px;
  }
}
</style>
